<template>
  <div class="icon" />
</template>

<script>
const cache = new Map();
export default {
  name: "IconComponent",
  props: {
    name: {
      type: String,
      required: true
    }
  },
  async beforeMount() {
    if (!cache.has(this.name)) {
      try {
        const component = require(`/src/assets/svg/${this.name}.svg`)
        cache.set(this.name, fetch(component).then(r => r.text()));
      } catch (e) {
        cache.delete(this.name);
      }
    }
    if (cache.has(this.name)) {
      this.$el.innerHTML = await cache.get(this.name);
    }
  }
}
</script>

<style scoped>
.icon{
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>